import React from 'react';
import { IOpportunitiesTabPanel } from './interfaces';
import { TabPanel } from '../..';
import { ManagedDataTable } from '../../../ManagedDataTable';
import { IManagedDataTable } from '../../../ManagedDataTable/interfaces';
import { useGetOpportunities } from '../../../../reactQuery/opportunities';
import { Item } from '../../../../api/opportunitiesApi/interfaces';
import { getColumns } from './helpers';

export const OpportunitiesTabPanel: React.FC<IOpportunitiesTabPanel> = ({
  value,
  index,
  filter,
  id,
  storageKey,
}): JSX.Element => {
  return (
    <TabPanel value={value} index={index}>
      <ManagedDataTable
        query={useGetOpportunities as IManagedDataTable<Item>['query']}
        columns={getColumns(filter === 'client', filter === 'contact')}
        storageKey={storageKey}
        initialSort={{ field: 'createdAt', sort: 'desc' }}
        filter={[
          {
            field: filter,
            operator: '=',
            value: id,
          },
        ]}
      />
    </TabPanel>
  );
};
